import APIRequestState from './_util/api-request';

class ResetPasswordState extends APIRequestState {
  get method() { return 'POST'; }
  get url() { return '/auth/resetPassword'; }
}

export default ResetPasswordState;



// WEBPACK FOOTER //
// ./spa/state/reset-password.jsx